export enum DateFilterTypeEnum {
  Custom = 0,
  Today = 1,
  ThisWeek = 2,
  ThisMonth = 3,
  ThisQuarter = 4,
  ThisYear = 5,
  LastWeek = 6,
  LastMonth = 7,
  LastQuarter = 8,
  LastYear = 9,
  AllDates = 10,
}
